import OrganizationService from "src/services/OrganizationService";

export const types = {
	GET: "current/get",
};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.organization,
 **/

const module = {
	state: {
		organization: {},
	},
	mutations: {
		[types.GET] (state, organization) {
			state.organization = organization;
		},
	},
	getters: {},
	actions: {
		async [types.GET] ({ commit }) {
			const org = await OrganizationService.getCurrent();
			commit(types.GET, org);
			return org;
		},
	},
	types: types,
};
export default module;
